import { styled } from "@mui/material";

interface StyledIconProps {
  size: "inherit" | "xs" | "small" | "medium" | "big" | "xl";
  color: string;
  fill?: number;
}

export const StyledIcon = styled("span")<StyledIconProps>`
  &&& {
    font-size: ${({ size }) =>
      (size === "inherit" && "inherit") ||
      (size === "xl" && "32px") ||
      (size === "big" && "24px") ||
      (size === "medium" && "16px") ||
      (size === "small" && "12px") ||
      (size === "xs" && "8px")};
    color: ${({ color }) => color};
    font-variation-settings: ${({ fill }) =>
      Boolean(fill) ? `"FILL" ${fill}` : undefined};
  }
`;
